import { BookingDateAndTimeStep } from 'src/modules/booking/components/booking-date-and-time-step'
import { BookingThemedRoot } from 'src/modules/booking/components/booking-themed-root'
import { PoweredBy } from 'src/modules/booking/components/powered-by'
import { Typography } from 'src/modules/core/components'
import { RescheduleBlocked } from 'src/modules/reschedule/components'

import { BookingDetailsHeader } from '../booking-details/booking-details-header'
import classes from '../booking-details/booking-details.module.scss'
import { useRescheduleContext } from './use-reschedule-context'

export function RescheduleBooking() {
  const f = useRescheduleContext()

  if (!f.isLoading && f.hasError) {
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <div className={classes.card}>
            <div className={classes.loadingMessage}>
              <div>
                <Typography variant="h2" className={classes.title}>
                  Unable to locate booking
                </Typography>
                <Typography variant="body" className={classes.subtitle}>
                  It might have been cancelled by the provider
                </Typography>
              </div>
            </div>
          </div>
          <PoweredBy className={classes.poweredBy} />
        </div>
      </div>
    )
  }

  if (!f.isLoading && !f.data) return null

  return (
    <BookingThemedRoot providerId={f.providerId} className={classes.root}>
      <div className={classes.container}>
        <div className={classes.card}>
          {f.isLoading ? (
            <div className={classes.loadingMessage}>
              <Typography variant="body">Loading...</Typography>
            </div>
          ) : f.blockedView ? (
            <RescheduleBlocked view={f.blockedView} />
          ) : (
            <>
              <BookingDetailsHeader
                providerName={f.data.providerName}
                logoUrl={f.data.logoUrl}
                subtitle="Choose a new date and time"
              />
              <BookingDateAndTimeStep
                providerId={f.data.providerId}
                isRescheduling={true}
                allowChangingAppointmentType={f.data.allowChangingAppointmentType}
                initialData={f.data.initialData}
                appointmentTypes={f.data.appointmentTypes}
                rescheduleCode={f.data.rescheduleCode}
                onNext={f.handleReschedule}
              />
            </>
          )}
        </div>
        <PoweredBy className={classes.poweredBy} />
      </div>
    </BookingThemedRoot>
  )
}
